// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import md5 from 'js-md5'
import i18n from './util/vueIN'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import App from './App'
// import Vconsole from 'vconsole'
// import FastClick from 'fastclick'
import router from './router'
import webBuryPoint from './util/webBuryPoint'
import common from './util/common'
import mapBoxGl from 'mapbox-gl'
import wx from 'weixin-js-sdk'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/dist/css/swiper.css'
import '@/assets/css/main.css'
import '@/assets/css/home.css'
import '@/assets/css/public.css'
import '@/assets/scss/media.scss'

Vue.config.productionTip = false
Vue.prototype.wx = wx
Vue.prototype.common = common
// Vue.prototype.webBuryPoint = webBuryPoint
Vue.prototype.$md5 = md5
Vue.prototype.mbgl = mapBoxGl
ElementUI.Dialog.props.lockScroll.default = false // 解决弹窗出现时屏幕抖动

Vue.use(ElementUI)

Vue.use(VueAwesomeSwiper)
// console.log(Vue.prototype.common.getFacilityInfo())

// 默认调用一次生成一个sessionid
Vue.prototype.common.sessionidGet()
// 默认币种
Vue.prototype.common.currencySet()
// 手机上的打印
// Vue.prototype.$vConsole = new Vconsole()

// var ip = window.location.host
// Vue.prototype.common.getUserIP()
// console.log('ip', ip.split(':')[0])

// ios input 点击两次才能获取焦点问题
// if ('addEventListener' in document) {
//   document.addEventListener('DOMContentLoaded', () => {
//     FastClick.attach(document.body)
//   }, false)
// }
// FastClick.prototype.focus = function (targetElement) {
//   targetElement.focus()
// }
// const ver = navigator.userAgent.match(/cpu iphone os (.*?) like mac os/)

// // 非IOS系统
// if (!ver) {
//   // 引入fastclick 做相关处理
//   FastClick.attach(document.body)
// } else {
//   if (parseInt(ver[1]) < 11) {
//     // 引入fastclick 做相关处理
//     FastClick.attach(document.body)
//   }
// }

// 注册全局混入
Vue.mixin(webBuryPoint)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  render: h => h(App),
  template: '<App/>'
})

// 全局全局前置守卫
// 离开页面
router.beforeEach((to, from, next) => {
  // to : 将要进入的目标路由对象
  // from : 即将离开的目标路由对象

  // 触发离开页面日志记录
  router.app.closePage('close')

  var outPageTime = parseInt(new Date().getTime())
  var data = {
    'toPage': to.name,
    'fromPage': from.name,
    'inPageTime': '',
    'outPageTime': outPageTime
  }
  var datajson = JSON.stringify(data)
  sessionStorage.setItem('pageInfoData', datajson)

  next()
})

// 进入页面
router.afterEach((to, from) => {
  console.log('进入页面 ' + to)
  // 回到顶部
  window.scrollTo(0, 0)
  // 触发进入页面日志记录
  router.app.trackPageView(to.name)
})

Vue.directive('tooltipHide', {
  inserted (el, binding) {
    const tooltipId = el.attributes['aria-describedby'].nodeValue
    el.immediateHide = () => {
      const tooltipEl = document.getElementById(tooltipId)
      if (tooltipEl) tooltipEl.style.display = 'none'
    }
    el.addEventListener('mouseleave', el.immediateHide)
  }
})



// WEBPACK FOOTER //
// ./src/main.js